import "../../rateCard/rateCard.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Table from "react-bootstrap/Table";
import {
  getAllTrainingMaterial,
  getAllTrainingMaterialByCategory,
  viewdownloadDocument,
  deleteTrainingMaterial,
} from "../knowledgeMangementApi";
import TrashIcon from "../../../../images/TrashIcon.png";
import { ConfirmPopover } from "../../../../preregcamps/confirmPopover/confirmPopover";
import { ErrorPopover } from "../../../../common/ErrorPopover/errorPopover";
import {
  DialogContent,
  Dialog,
  DialogActions,
  IconButton,
} from "@mui/material";
import { PROD } from "../../../../common/constants";
import {
  Card,
  CardContent,
  Container,
  Stack,
  Box,
  Typography,
  Grid,
  Button,
  Tooltip,
} from "@mui/material";
import { stakeHolderCategory } from "../../../../registration/screens/registration/dashboardStakeHolder";
import { DataGrid } from "@mui/x-data-grid";
import CustomDataGridToolbar from "../../../../common/customDataGridToolbar";
import { NO_DATA_AVAILABLE } from "../../../../common/constants";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ConfirmationPopover } from "../../../../common/commonPopovers/confirmationPopover";
import {
  DeleteIcon,
  DownloadIcon,
  RemoveRedEyeIcon,
} from "../../../../common/icons";

function ViewKnowledgeManagement() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [viewTraningMaterial, setViewTraningMaterial] = useState();
  const [deleteTraningMaterial, setDeleteTraningMaterial] = useState();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalClose1 = () => setLogModalOpen1(false);
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [deleteItem, setDeleteItem] = useState();
  const [isApiCalled, setIsApiCalled] = useState(false);

  useEffect(() => {
    stakeHolderCategory
      ? getAllTrainingMaterialByCategory(
          stakeHolderCategory,
          setViewTraningMaterial
        )
      : getAllTrainingMaterial(setViewTraningMaterial);
  }, []);

  const viewanddownloadDocument = (
    e,
    fileName,
    containerName,
    finalfileName
  ) => {
    e.preventDefault();
    viewdownloadDocument(fileName, containerName, finalfileName);
  };

  const onDeleteTrainingMAterial = (item) => {
    setDeleteItem(item);
    handleConfirmLogModalOpen();
  };

  // function onConfirmCallBack() {
  //   handleConfirmLogModalClose();
  //   deleteTrainingMaterial(deleteItem, setDeleteTraningMaterial);
  // }

    const onConfirmCallBack = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await deleteTrainingMaterial(deleteItem, setDeleteTraningMaterial);
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogConfirmModalOpen(false);
            setIsApiCalled(false);
        }
    };

  function onCancelBack() {
    handleConfirmLogModalClose();
  }

  useEffect(() => {
    if (deleteTraningMaterial) {
      if (deleteTraningMaterial.status === "SUCCESS") {
        toast.success(deleteTraningMaterial?.description);
        // navigate('/viewKnowledgeManagement');
      } else
        toast.error(
          deleteTraningMaterial?.description
            ? deleteTraningMaterial?.description
            : "Error"
        );
      getAllTrainingMaterial(setViewTraningMaterial);
    }
  }, [deleteTraningMaterial]);

  const openLink = (link) => {
    const newWindow = window.open(link, "_blank");
    newWindow.focus();
  };

  const trainingcol = [
    {
      field: "fileName",
      headerName: t("resource.documentName"),
      width: 250,
    },
    {
      field: "stakeholderCategory",
      headerName: t("resource.stakeholderType"),
      width: 250,
    },
    // {
    //   field: "stakeholdertype",
    //   headerName: "Delete",
    //   width: 120,
    //   hide: stakeHolderCategory && true,
    //   renderCell: (params) => (
    //     <img
    //       src={TrashIcon}
    //       style={{ cursor: "pointer" }}
    //       alt="TrashIcon"
    //       onClick={(e) => onDeleteTrainingMAterial(params?.row)}
    //     />
    //   ),
    // },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 250,
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={(e) =>
                  viewdownloadDocument(
                    params?.row?.fileStorage,
                    params?.row?.fileName,
                    "View"
                  )
                }
              >
                <RemoveRedEyeIcon />
              </IconButton>
            </Tooltip>
            {(!stakeHolderCategory ||
              (params?.row?.fileDownloadable && stakeHolderCategory)) && (
              <Tooltip title="Download">
                <IconButton
                  color="primary"
                  onClick={() =>
                    viewdownloadDocument(
                      params?.row?.fileStorage,
                      params?.row?.fileName,
                      "Download"
                    )
                  }
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            )}

            {!stakeHolderCategory && (
              <Tooltip title="Delete">
                <IconButton
                  color="error"
                  onClick={() => onDeleteTrainingMAterial(params?.row)}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      field: "externalVideoLink",
      headerName: "View External Link",
      width: 200,
      renderCell: (params) =>
        params.value && (
          <Button
            sx={{ minWidth: 70 }}
            variant="outlined"
            onClick={() => openLink(params?.value)}
          >
            {t("resource.view")}
          </Button>
        ),
    },
  ];
  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className="pageNumberingResc">RES09</p>}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h5" gutterBottom>
            {t("resource.viewKnowledgeManagement")}
          </Typography>
        </Stack>
        {viewTraningMaterial && (
          <Grid container spacing={1} sx={{ mt: 1 }}>
            <Grid item xs={12} lg={12}>
              {viewTraningMaterial?.length !== 0 ? (
                <Box sx={{ height: 430, width: "100%", mt: 2 }}>
                  <DataGrid
                    rows={viewTraningMaterial}
                    columns={trainingcol}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    getRowId={(row) => row?.id}
                    initialState={{
                      sorting: {
                        sortModel: [{ field: "mapped", sort: "asc" }],
                      },
                    }}
                    components={{
                      Toolbar: CustomDataGridToolbar,
                    }}
                    componentsProps={{
                      toolbar: {
                        rows: viewTraningMaterial,
                        columns: trainingcol,
                        fileName: "KnowledgeManagementList.xlsx",
                      },
                    }}
                  />
                </Box>
              ) : (
                <Typography
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ fontWeight: "bold" }}
                >
                  {NO_DATA_AVAILABLE}
                </Typography>
              )}
            </Grid>
          </Grid>
        )}
      </Container>
      <ConfirmationPopover
        onOpen={logConfirmModalOpen}
        onConfirm={onConfirmCallBack}
        onClose={onCancelBack}
        action="Delete"
      />
    </>
  );
}
export default ViewKnowledgeManagement;
